import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { money } from "@/lib/api";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="text-sm font-semibold text-slate-700">{label}</span>
    <div className="mt-1">{children}</div>
  </label>
);

export const AccountSelect = ({ accounts, value, onChange, testid, placeholder = "Select account" }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      {accounts.map((a) => (
        <SelectItem key={a.id} value={a.id}>{a.name} ...{a.number_last4} ({money(a.balance)})</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
